import classNames from 'classnames';
import { Button } from 'palette/Button';
import { useTranslation } from '@common/Hooks/useTranslation';
import { FooterHeader } from './FooterHeader';
import { FooterIconApp } from './FooterIconApp';

import '../styles/FooterNavigationSocial.scss';

export function FooterNavigationSocial({
    socialLinks,
    appLinks,
    customClass
}) {
    const translate = useTranslation();
    const filteredSocialLinks = socialLinks.filter(link => link.url);
    const filteredAppLinks = appLinks.filter(link => link.url && link.isEnabled);

    return (
        <div className={classNames('react-footer-navigation-social', customClass)}>
            {filteredSocialLinks.length > 0 && (
                <div className="react-footer-navigation-social__block">
                    <FooterHeader
                        title={translate('footer.follow_boozt.label')}
                    />
                    <div className="react-footer-navigation-social__icons">
                        {filteredSocialLinks.map(({ name, url }) => (
                            <Button
                                key={name}
                                aria-label={name}
                                href={url}
                                iconColor="white"
                                iconName={`palette_${name}`}
                                rel="noopener noreferrer"
                                shape="round"
                                target="_blank"
                                theme="dark"
                            />
                        ))}
                    </div>
                </div>
            )}
            {filteredAppLinks.length > 0 && (
                <div className="react-footer-navigation-social__block">
                    <FooterHeader
                        title={translate('footer.get_our_app.label')}
                    />
                    {filteredAppLinks.map(({ url, name }) => (
                        <FooterIconApp
                            key={name}
                            name={name}
                            url={url}
                        />
                    ))}
                </div>
            )}
        </div>

    );
}
